import initialState from "./initialState";
import Immutable from "seamless-immutable";
import { types } from "../actions/beaconActions";

export default function beaconsReducer(
  state = Immutable(initialState.beacon),
  action,
) {
  switch (action.type) {
    case types.GET_BEACON_IN_ZONE_REQUEST: {
      return state.merge({ fetching: true, list: [] });
    }
    case types.GET_BEACON_IN_ZONE_SUCCESS: {
      const { beacons } = action;
      return state.merge({ fetching: false, list: beacons });
    }
    case types.GET_BEACON_IN_ZONE_FAILURE: {
      return state.merge({ fetching: false });
    }

    default:
      return state;
  }
}
